import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '../../helpers'
import { ResidentTermDirectoryDetail } from '../../models'

export const useResidentTermDirectoryDetail = (
    deliverableId: number,
    directoryId: number,
) => {
    const directoryDetailQueryKey = [
        'resident-term-directory',
        deliverableId,
        directoryId,
    ] as const

    const {
        data: directory,
        isLoading: isLoadingDirectory,
        error: errorDirectory,
    } = useQuery<ResidentTermDirectoryDetail>({
        queryKey: directoryDetailQueryKey,
        queryFn: async () => {
            const res = await axiosInstance.get<ResidentTermDirectoryDetail>(
                `/document-audit/deliverable/${deliverableId}/resident-term-directory/${directoryId}/`,
            )
            return res.data
        },
        enabled: deliverableId !== -1 && directoryId !== -1,
    })

    return {
        directory,
        isLoadingDirectory,
        errorDirectory,
        directoryDetailQueryKey,
    }
}
